module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade Solicitante")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "show-text-danger-unidade": _vm.showTextDangerUnidadeSolicitante
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSolicitante(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional Solicitante")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "show-text-danger-profissional": _vm.showTextDangerProfissionalSolicitante
    },
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalSolicitante(profissionalSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade Prestadora")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "show-text-danger-unidade": _vm.showTextDangerUnidadeSolicitante
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadePrestadora(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional Prestador")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "show-text-danger-profissional": _vm.showTextDangerProfissionalSolicitante
    },
    on: {
      "setProfissionalSelecionado": function (profissionalSelecionado) {
        _vm.setProfissionalPrestador(profissionalSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Paciente")]), _vm._v(" "), _c('select-paciente', {
    on: {
      "setPacienteSelecionado": function (paciente) {
        _vm.setPacienteSelecionado(paciente);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Grupo de Procedimento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grupoSelecionado),
      expression: "grupoSelecionado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "grupo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grupoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.setGrupoSelecionado()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o grupo...")]), _vm._v(" "), _vm._l((_vm.grupos), function(grupo, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": grupo
      }
    }, [_vm._v(_vm._s(grupo.codigo) + " - " + _vm._s(grupo.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Sub-Grupo")]), _vm._v(" "), _c('select-subgrupo', {
    on: {
      "setSubgrupoSelecionado": function (subgrupoSelecionado) {
        _vm.setSubgrupoSelecionado(subgrupoSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Marcador")]), _vm._v(" "), _c('select-usuario', {
    attrs: {
      "nivel": "marcador"
    },
    on: {
      "setUsuarioSelecionado": function (usuario) {
        _vm.setUsuarioMarcadorSelecionado(usuario);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Regulador")]), _vm._v(" "), _c('select-usuario', {
    attrs: {
      "nivel": "regulador"
    },
    on: {
      "setUsuarioSelecionado": function (usuario) {
        _vm.setUsuarioReguladorSelecionado(usuario);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo_atendimento),
      expression: "filtros.tipo_atendimento"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "tp_solicitacao",
      "id": "tp_solicitacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo_atendimento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_ATENDIMENTO.INDIVIDUAL
    }
  }, [_vm._v("Individual")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_ATENDIMENTO.AGRUPADO
    }
  }, [_vm._v("Agrupado")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de Unidade")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo_unidade),
      expression: "filtros.tipo_unidade"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo_unidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_UNIDADE.UNIDADE_BASICA
    }
  }, [_vm._v("Unidade básica de saúde")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_UNIDADE.HOSPITAL
    }
  }, [_vm._v("Hospital")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dt_nascimento"
    }
  }, [_vm._v("Solicitado")]), _vm._v(" "), _c('data-filtro', {
    attrs: {
      "name": "solicitado"
    },
    on: {
      "operadorSelecionado": function($event) {
        _vm.filtros.solicitadoOperador = $event
      },
      "dataSelecionada": function($event) {
        _vm.filtros.solicitado = $event
      },
      "data2Selecionada": function($event) {
        _vm.filtros.solicitado2 = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dt_nascimento"
    }
  }, [_vm._v("Agendado")]), _vm._v(" "), _c('data-filtro', {
    attrs: {
      "name": "agendado"
    },
    on: {
      "operadorSelecionado": function($event) {
        _vm.filtros.agendadoOperador = $event
      },
      "dataSelecionada": function($event) {
        _vm.filtros.agendado = $event
      },
      "data2Selecionada": function($event) {
        _vm.filtros.agendado2 = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "dt_nascimento"
    }
  }, [_vm._v("Regulado")]), _vm._v(" "), _c('data-filtro', {
    attrs: {
      "name": "regulado"
    },
    on: {
      "operadorSelecionado": function($event) {
        _vm.filtros.reguladoOperador = $event
      },
      "dataSelecionada": function($event) {
        _vm.filtros.regulado = $event
      },
      "data2Selecionada": function($event) {
        _vm.filtros.regulado2 = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.MARCADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.MARCADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.MARCADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Marcada ")]), _vm._v(" "), (this.$store.state.user.nivel == 'administrador') ? _c('div', [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.EM_REGULACAO,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.EM_REGULACAO) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.EM_REGULACAO,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Em regulação ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REGULADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.REGULADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.REGULADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Regulada ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.NEGATIVADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.NEGATIVADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.NEGATIVADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Negativada ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Informação pendente ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Informação adicional ")])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CONFIRMADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.CONFIRMADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.CONFIRMADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Confirmada ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CANCELADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.CANCELADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.CANCELADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Cancelada ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.FALTA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.FALTA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.FALTA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Falta ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacoes),
      expression: "filtros.situacoes"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REALIZADA,
      "checked": Array.isArray(_vm.filtros.situacoes) ? _vm._i(_vm.filtros.situacoes, _vm.SITUACAO_SOLICITACAO.REALIZADA) > -1 : (_vm.filtros.situacoes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.filtros.situacoes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.SITUACAO_SOLICITACAO.REALIZADA,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.filtros, "situacoes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.filtros, "situacoes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.filtros, "situacoes", $$c)
        }
      }
    }
  }), _vm._v("Realizada ")])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "box-footer text-right"
  }, [(_vm.pdf) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.getPDF()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Recarregar PDF")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.finalizado,
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Solicitação",
      "id": "resultado"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable) && !_vm.pdf && !_vm.filtros.sintetico) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.situacao),
      expression: "ativos.situacao"
    }]
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.tipo),
      expression: "ativos.tipo"
    }]
  }, [_vm._v("Tipo")]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.dt_solicitacao),
      expression: "ativos.dt_solicitacao"
    }]
  }, [_vm._v("Dt. Solicitação")]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.dt_realizacao),
      expression: "ativos.dt_realizacao"
    }]
  }, [_vm._v("Dt. Realização")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.cidadao),
      expression: "ativos.cidadao"
    }]
  }, [_vm._v("Paciente")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.endereco),
      expression: "ativos.endereco"
    }]
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.cidade),
      expression: "ativos.cidade"
    }]
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.bairro),
      expression: "ativos.bairro"
    }]
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.telefone),
      expression: "ativos.telefone"
    }]
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.rg),
      expression: "ativos.rg"
    }]
  }, [_vm._v("RG")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.nome_mae),
      expression: "ativos.nome_mae"
    }]
  }, [_vm._v("Nome da Mãe")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.dt_nascimento),
      expression: "ativos.dt_nascimento"
    }]
  }, [_vm._v("Dt. Nasc")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.idade),
      expression: "ativos.idade"
    }]
  }, [_vm._v("Idade")]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.id),
      expression: "ativos.id"
    }]
  }, [_vm._v("ID")]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.quantidade),
      expression: "ativos.quantidade"
    }]
  }, [_vm._v("Qtd.")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.tipo_consulta),
      expression: "ativos.tipo_consulta"
    }]
  }, [_vm._v("Consulta")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.procedimento),
      expression: "ativos.procedimento"
    }]
  }, [_vm._v("Procedimento")]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.valor_prestador),
      expression: "ativos.valor_prestador"
    }]
  }, [_vm._v("Valor Prestador")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.valor),
      expression: "ativos.valor"
    }]
  }, [_vm._v("Valor Solicitante")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.valor_s),
      expression: "ativos.valor_s"
    }]
  }, [_vm._v("Valor de referência")]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.unid_solic),
      expression: "ativos.unid_solic"
    }]
  }, [_vm._v("Unid. Solicitante")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.unid_prest),
      expression: "ativos.unid_prest"
    }]
  }, [_vm._v("Unid. Realizadora")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.prof_prest),
      expression: "ativos.prof_prest"
    }]
  }, [_vm._v("Prof. Prestador")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.prof_solic),
      expression: "ativos.prof_solic"
    }]
  }, [_vm._v("Prof. Solicitante")]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.marcador),
      expression: "ativos.marcador"
    }]
  }, [_vm._v("Marcador")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.regulador),
      expression: "ativos.regulador"
    }]
  }, [_vm._v("Regulador")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.agp_unidades),
      expression: "ativos.agp_unidades"
    }]
  }, [_vm._v("Agrupamento de Unidades")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.usu_cancelamento),
      expression: "ativos.usu_cancelamento"
    }]
  }, [_vm._v("Usuário Cancelamento")]) : _vm._e(), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ativos.dt_cancelamento),
      expression: "ativos.dt_cancelamento"
    }]
  }, [_vm._v("Dt. Cancelamento")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.situacao),
        expression: "ativos.situacao"
      }]
    }, [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.tipo),
        expression: "ativos.tipo"
      }]
    }, [_vm._v(_vm._s(_vm._f("tipoAtendimento")(item.solicitacao.tipo_atendimento)))]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.dt_solicitacao),
        expression: "ativos.dt_solicitacao"
      }]
    }, [_vm._v(_vm._s(_vm._f("dataFormatadaHora")(item.solicitacao.created_at)))]) : _vm._e(), _vm._v(" "), (item.contrato_procedimento_atendimento || item.contrato_subgrupo_atendimento) ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.dt_realizacao),
        expression: "ativos.dt_realizacao"
      }]
    }, [_vm._v(_vm._s(_vm._f("dataFormatadaHora")((item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento + " " + item.contrato_procedimento_atendimento.hora_inicial : item.contrato_subgrupo_atendimento.data_atendimento + " " + item.contrato_subgrupo_atendimento.hora_inicial))))]) : _c('td', [_vm._v("SEM DATA DEFINIDA")]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.cidadao),
        expression: "ativos.cidadao"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.cidadao),
        expression: "ativos.cidadao"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.endereco) + ", " + _vm._s(item.solicitacao.paciente.numero_endereco))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.cidade),
        expression: "ativos.cidade"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.cidade.nome))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.bairro),
        expression: "ativos.bairro"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.bairro))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.telefone),
        expression: "ativos.telefone"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.telefone))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.rg),
        expression: "ativos.rg"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.rg))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.nome_mae),
        expression: "ativos.nome_mae"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.paciente.nome_mae))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.dt_nascimento),
        expression: "ativos.dt_nascimento"
      }]
    }, [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.paciente.data_nascimento)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.idade),
        expression: "ativos.idade"
      }]
    }, [_vm._v(_vm._s(_vm._f("idade")(item.solicitacao.paciente.data_nascimento)))]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.id),
        expression: "ativos.id"
      }]
    }, [_vm._v(_vm._s(_vm._f("formatarCodigo")(item.solicitacao.id)))]) : _vm._e(), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.quantidade),
        expression: "ativos.quantidade"
      }]
    }, [_vm._v(_vm._s(item.quantidade))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.tipo_consulta),
        expression: "ativos.tipo_consulta"
      }]
    }, [_vm._v(_vm._s(_vm._f("tipoConsulta")(item.tipo_consulta)))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.procedimento),
        expression: "ativos.procedimento"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('div', [(item.contrato_procedimento_atendimento) ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.valor_prestador),
        expression: "ativos.valor_prestador"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento_atendimento.contrato_procedimento.valor))]) : _c('td', [_vm._v("SEM VALOR DEFINIDO")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.valor),
        expression: "ativos.valor"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.valor))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.valor_s),
        expression: "ativos.valor_s"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.procedimento.valor_referencia))]) : _vm._e(), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.unid_solic),
        expression: "ativos.unid_solic"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), (item.contrato_procedimento_atendimento || item.contrato_subgrupo_atendimento) ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.unid_prest),
        expression: "ativos.unid_prest"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))]) : _c('td', [_vm._v("SEM UNIDADE DEFINIDA")]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.prof_prest),
        expression: "ativos.prof_prest"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.prof_solic),
        expression: "ativos.prof_solic"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.profissional.nome))]), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.marcador),
        expression: "ativos.marcador"
      }]
    }, [_vm._v(_vm._s(item.solicitacao.usuario.name))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.regulador),
        expression: "ativos.regulador"
      }]
    }, [_vm._v(_vm._s(_vm.verificarRegulacao(item.solicitacao)))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.agp_unidades),
        expression: "ativos.agp_unidades"
      }]
    }, [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.tipo_unidade.nome))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 'administrador') ? _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.usu_cancelamento),
        expression: "ativos.usu_cancelamento"
      }]
    }, [_vm._v(_vm._s(_vm.verificarCancelamento(item.solicitacao).text))]) : _vm._e(), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ativos.dt_cancelamento),
        expression: "ativos.dt_cancelamento"
      }]
    }, [_vm._v(_vm._s(_vm.verificarCancelamento(item.solicitacao).data))])])
  }))])]), _vm._v(" "), (_vm.dataTable.data && _vm.dataTable.data.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getCSV($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" CSV")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.situacao),
      expression: "ativos.situacao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.situacao) ? _vm._i(_vm.ativos.situacao, null) > -1 : (_vm.ativos.situacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.situacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "situacao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "situacao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "situacao", $$c)
        }
      }
    }
  }), _vm._v("Situação ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.tipo),
      expression: "ativos.tipo"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.tipo) ? _vm._i(_vm.ativos.tipo, null) > -1 : (_vm.ativos.tipo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.tipo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "tipo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "tipo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "tipo", $$c)
        }
      }
    }
  }), _vm._v("Tipo ")])]), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.dt_solicitacao),
      expression: "ativos.dt_solicitacao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.dt_solicitacao) ? _vm._i(_vm.ativos.dt_solicitacao, null) > -1 : (_vm.ativos.dt_solicitacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.dt_solicitacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "dt_solicitacao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "dt_solicitacao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "dt_solicitacao", $$c)
        }
      }
    }
  }), _vm._v("Dt. Solicitação ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.dt_realizacao),
      expression: "ativos.dt_realizacao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.dt_realizacao) ? _vm._i(_vm.ativos.dt_realizacao, null) > -1 : (_vm.ativos.dt_realizacao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.dt_realizacao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "dt_realizacao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "dt_realizacao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "dt_realizacao", $$c)
        }
      }
    }
  }), _vm._v("Dt. Realização ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.cidadao),
      expression: "ativos.cidadao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.cidadao) ? _vm._i(_vm.ativos.cidadao, null) > -1 : (_vm.ativos.cidadao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.cidadao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "cidadao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "cidadao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "cidadao", $$c)
        }
      }
    }
  }), _vm._v("Cidadão ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.cidade),
      expression: "ativos.cidade"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.cidade) ? _vm._i(_vm.ativos.cidade, null) > -1 : (_vm.ativos.cidade)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.cidade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "cidade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "cidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "cidade", $$c)
        }
      }
    }
  }), _vm._v("Cidade ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.bairro),
      expression: "ativos.bairro"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.bairro) ? _vm._i(_vm.ativos.bairro, null) > -1 : (_vm.ativos.bairro)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.bairro,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "bairro", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "bairro", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "bairro", $$c)
        }
      }
    }
  }), _vm._v("Bairro ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.telefone),
      expression: "ativos.telefone"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.telefone) ? _vm._i(_vm.ativos.telefone, null) > -1 : (_vm.ativos.telefone)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.telefone,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "telefone", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "telefone", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "telefone", $$c)
        }
      }
    }
  }), _vm._v("Telefone ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.rg),
      expression: "ativos.rg"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.rg) ? _vm._i(_vm.ativos.rg, null) > -1 : (_vm.ativos.rg)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.rg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "rg", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "rg", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "rg", $$c)
        }
      }
    }
  }), _vm._v("RG ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.nome_mae),
      expression: "ativos.nome_mae"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.nome_mae) ? _vm._i(_vm.ativos.nome_mae, null) > -1 : (_vm.ativos.nome_mae)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.nome_mae,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "nome_mae", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "nome_mae", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "nome_mae", $$c)
        }
      }
    }
  }), _vm._v("Nome da Mãe ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.dt_nascimento),
      expression: "ativos.dt_nascimento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.dt_nascimento) ? _vm._i(_vm.ativos.dt_nascimento, null) > -1 : (_vm.ativos.dt_nascimento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.dt_nascimento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "dt_nascimento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "dt_nascimento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "dt_nascimento", $$c)
        }
      }
    }
  }), _vm._v("Dt. Nasc ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.idade),
      expression: "ativos.idade"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.idade) ? _vm._i(_vm.ativos.idade, null) > -1 : (_vm.ativos.idade)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.idade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "idade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "idade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "idade", $$c)
        }
      }
    }
  }), _vm._v("Idade ")])]), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.id),
      expression: "ativos.id"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.id) ? _vm._i(_vm.ativos.id, null) > -1 : (_vm.ativos.id)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.id,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "id", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "id", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "id", $$c)
        }
      }
    }
  }), _vm._v("ID ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.quantidade),
      expression: "ativos.quantidade"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.quantidade) ? _vm._i(_vm.ativos.quantidade, null) > -1 : (_vm.ativos.quantidade)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.quantidade,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "quantidade", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "quantidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "quantidade", $$c)
        }
      }
    }
  }), _vm._v("Quantidade")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.tipo_consulta),
      expression: "ativos.tipo_consulta"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.tipo_consulta) ? _vm._i(_vm.ativos.tipo_consulta, null) > -1 : (_vm.ativos.tipo_consulta)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.tipo_consulta,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "tipo_consulta", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "tipo_consulta", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "tipo_consulta", $$c)
        }
      }
    }
  }), _vm._v("Consulta")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.procedimento),
      expression: "ativos.procedimento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.procedimento) ? _vm._i(_vm.ativos.procedimento, null) > -1 : (_vm.ativos.procedimento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.procedimento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "procedimento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "procedimento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "procedimento", $$c)
        }
      }
    }
  }), _vm._v("Procedimento ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [(this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.valor),
      expression: "ativos.valor"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.valor) ? _vm._i(_vm.ativos.valor, null) > -1 : (_vm.ativos.valor)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.valor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "valor", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "valor", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "valor", $$c)
        }
      }
    }
  }), _vm._v("Valor ")])]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.valor_s),
      expression: "ativos.valor_s"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.valor_s) ? _vm._i(_vm.ativos.valor_s, null) > -1 : (_vm.ativos.valor_s)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.valor_s,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "valor_s", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "valor_s", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "valor_s", $$c)
        }
      }
    }
  }), _vm._v("Valor S ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.unid_solic),
      expression: "ativos.unid_solic"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.unid_solic) ? _vm._i(_vm.ativos.unid_solic, null) > -1 : (_vm.ativos.unid_solic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.unid_solic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "unid_solic", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "unid_solic", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "unid_solic", $$c)
        }
      }
    }
  }), _vm._v("Unid. Solicitante ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.unid_prest),
      expression: "ativos.unid_prest"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.unid_prest) ? _vm._i(_vm.ativos.unid_prest, null) > -1 : (_vm.ativos.unid_prest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.unid_prest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "unid_prest", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "unid_prest", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "unid_prest", $$c)
        }
      }
    }
  }), _vm._v("Unid. Realizadora ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.prof_prest),
      expression: "ativos.prof_prest"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.prof_prest) ? _vm._i(_vm.ativos.prof_prest, null) > -1 : (_vm.ativos.prof_prest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.prof_prest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "prof_prest", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "prof_prest", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "prof_prest", $$c)
        }
      }
    }
  }), _vm._v("Prof. Prestador ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.prof_solic),
      expression: "ativos.prof_solic"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.prof_solic) ? _vm._i(_vm.ativos.prof_solic, null) > -1 : (_vm.ativos.prof_solic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.prof_solic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "prof_solic", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "prof_solic", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "prof_solic", $$c)
        }
      }
    }
  }), _vm._v("Prof. Solicitante ")])]), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.marcador),
      expression: "ativos.marcador"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.marcador) ? _vm._i(_vm.ativos.marcador, null) > -1 : (_vm.ativos.marcador)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.marcador,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "marcador", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "marcador", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "marcador", $$c)
        }
      }
    }
  }), _vm._v("Marcador ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [(this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.regulador),
      expression: "ativos.regulador"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.regulador) ? _vm._i(_vm.ativos.regulador, null) > -1 : (_vm.ativos.regulador)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.regulador,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "regulador", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "regulador", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "regulador", $$c)
        }
      }
    }
  }), _vm._v("Regulador ")])]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.agp_unidades),
      expression: "ativos.agp_unidades"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.agp_unidades) ? _vm._i(_vm.ativos.agp_unidades, null) > -1 : (_vm.ativos.agp_unidades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.agp_unidades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "agp_unidades", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "agp_unidades", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "agp_unidades", $$c)
        }
      }
    }
  }), _vm._v("Agrupamento de Unidades ")])]) : _vm._e(), _vm._v(" "), (this.$store.state.user.nivel != 'prestador') ? _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.usu_cancelamento),
      expression: "ativos.usu_cancelamento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.usu_cancelamento) ? _vm._i(_vm.ativos.usu_cancelamento, null) > -1 : (_vm.ativos.usu_cancelamento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.usu_cancelamento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "usu_cancelamento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "usu_cancelamento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "usu_cancelamento", $$c)
        }
      }
    }
  }), _vm._v("Usuário Cancelamento ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ativos.dt_cancelamento),
      expression: "ativos.dt_cancelamento"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.ativos.dt_cancelamento) ? _vm._i(_vm.ativos.dt_cancelamento, null) > -1 : (_vm.ativos.dt_cancelamento)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ativos.dt_cancelamento,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.ativos, "dt_cancelamento", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.ativos, "dt_cancelamento", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.ativos, "dt_cancelamento", $$c)
        }
      }
    }
  }), _vm._v("Data Cancelamento ")])]), _vm._v(" "), _c('br')])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Solicitações")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-609cc338"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/relatorios/solicitacoes/index.vue
// module id = 855
// module chunks = 0